import React from "react";
const TextInput = ({ type, label, register, name, required, pattern, maxLength, minLength, errors, defaultValue, value, rows, disabled, fontSize = "14px", padding, customClass, placeholder, onChange, innerRef, }) => {
    const { ref, ...rest } = register(name, {
        required,
        pattern,
        maxLength,
        minLength,
    });
    return (React.createElement("div", { className: `w-full py-2 flex flex-col lg:flex-row lg:items-center items-start gap-4` },
        React.createElement("p", { className: "lg:w-2/5 w-full" }, label),
        React.createElement("div", { className: "w-full flex flex-col" },
            React.createElement("input", { ...rest, type: type, ref: (e) => {
                    ref(e);
                    if (innerRef && e) {
                        innerRef.current = e;
                    }
                }, name: name, value: value, defaultValue: defaultValue, maxLength: maxLength?.value, minLength: minLength?.value, onKeyUp: (e) => onChange && onChange(e), placeholder: placeholder, disabled: disabled, className: `${customClass} ${disabled && "text-gray-400 bg-primary/20"}
         w-full px-4 py-3 placeholder:text-black/40 placeholder:font-light 
         border border-neutralBlue1 outline-none focus:outline-none rounded-md` }),
            errors[name] && (React.createElement("p", { className: "text-xs font-medium text-red-400" }, errors[name].message)))));
};
export default TextInput;
